export enum Sensitivity {
    Normal = 0,
    Personal = 1,
    Private = 2,
    Confidential = 3
}